/* Display-side hygiene for entity names offered to users as PEOPLE
 * (facet chips, top-entity strips). Extraction keeps everything — this
 * only decides top billing, mirroring the backend name-gate's stance
 * ("Affiant", pronouns, and object phrases never present as a person).
 * Filtered names stay reachable behind an explicit "generic references"
 * fold, so nothing becomes unfindable. */

const PRONOUNS_AND_ROLES = new Set([
  'i', 'me', 'he', 'she', 'they', 'we', 'you', 'it', 'him', 'her', 'them',
  'us', 'himself', 'herself', 'this writer', 'writer', 'affiant', 'declarant',
  'officer', 'deputy', 'detective', 'sergeant', 'unknown', 'unk', 'evidence',
  'dispatch', 'victim', 'suspect', 'witness', 'defendant',
]);

const LEADING_DETERMINER =
  /^(a|an|the|his|her|their|its|this|that|these|those|one|some|all|both|each|every)\s/i;

export function isPresentableParticipant(name) {
  const n = String(name || '').trim();
  if (n.length < 2) return false;
  if (PRONOUNS_AND_ROLES.has(n.toLowerCase())) return false;
  // "a trash bag", "the truck", "his truck", "one family member"
  if (LEADING_DETERMINER.test(n)) return false;
  // Names carry at least one uppercase letter; "bones", "grain truck",
  // "search personnel", and bare numbers ("911") do not.
  if (!/[A-Z]/.test(n)) return false;
  return true;
}
